<template>
  <div class="commodityStatistics">
    <headerNotice routerName="统计"></headerNotice>
    <div v-loading='loading' class="content">
      <div class="header">
    
    </div>
       <div class="cardBox">
            <el-row class="row" :gutter="18">
                <el-col :span="7">
                    <div class="box-card">
                        <i class="one"></i>
                        <div class="txt">
                            <p>今日活跃</p>
                            <span>{{items.activeToday}}</span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="7">
                    <div class="box-card">
                        <i class="two"></i>
                        <div class="txt">
                            <p>累计会员</p>
                            <span>{{items.userCount||0}}</span>
                        </div>
                             较昨日:+{{items.toDayMember||0}}
                    </div>
                </el-col>
                <el-col :span="7">
                    <div class="box-card">
                        <i class="four"></i>
                        <div class="txt">
                            <p>累计扫码</p>
                            <span>{{items.scanCount||0}}</span>
                        </div>
                        较昨日:+{{items.toDayScan||0}}
                    </div>
                </el-col>
            </el-row>
        </div>
      <sum-list :list="dataSum"/>
          <el-row style="padding-top: 10px;">
            <el-col :span="7" :offset="17">
              <el-radio-group @change='getDataByType' v-model="type" size="medium">
                <el-radio-button :label="0">活跃会员</el-radio-button>
                <el-radio-button :label="1">会员注册</el-radio-button>
                <el-radio-button :label="2">扫码趋势图</el-radio-button>
              </el-radio-group>
            </el-col>
          </el-row>
          <div v-show='type == 0' id="myChart" style="width: 100%;height:400px; margin-top: 20px;"></div>
              <div v-show='type == 1' id="myChartPie" style="width: 1368px;height:400px; margin-top: 20px;"></div>
          <!-- <div v-show='type === 1' id="myChartPie" style="width: 100%;height:400px; margin-top: 20px;"></div> -->
           <div v-show='type === 2' id="myChartScan" style="width: 100%;height:400px; margin-top: 20px;"></div>
    </div>
  </div>
</template>
<script>
import headerNotice from "../../components/common/headerNotice.vue";
import dateSelector from "../counts/dateSelector.vue";
import sumList from "../counts/sumList.vue";
import echarts from "echarts";
export default {
  components: {
    headerNotice,
    sumList,
    dateSelector
  },
  props: {},
  data() {
    return {
      loading:false,
      duration: [],
      pageSize: 10,
      totalCount: 0,
      currentPage: 1,
      type: 0,
      activeUserData: [],
      chartData: [],
      dataSum: [],
      Sacndata: [],
      items:[],
      activeCount:0,
      toDayMember:0,
      toDayScan:0
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 更改时间重新发请求
    getDataByTime(date) {
      this.duration = date
      this.getStatisticsByItem({
        StartTime: date[0],
        EndTime: date[1],
        Type: this.type,
        MaxResultCount: this.pageSize
      })
      this.currentPage = 1
    },
    // 更改类型重新发请求
    getDataByType(type) {
      let self=this;
      self.type = type
      if(type==1)
      {
         self.GetRegisterUser();
      }
       if(type==0)
      {
         self.GetActiveUser();
      }
        if(type==2)
      {
         self.GetSacnStatistics();
      }
    },
     // 订单数据
    getStatisticsByItem() {
      let self = this
      self.loading = true
      $http.GET({
        url:
          this.$store.state.apiUrl + "/api/services/app/AdminStatistics/GetStatistics",
        success(res) {
           self.items = res
           self.dataSum = self.getDataSum(res)
          self.loading = false
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
  // GetRegisterUser
    GetRegisterUser() {
      let self = this
      self.loading = true
      $http.GET({
        url:
          this.$store.state.apiUrl + "/api/services/app/AdminStatistics/GetRegisterUser",
        success(res) {
           self.chartData = res
             self.initChart();

          self.loading = false
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
    GetActiveUser() {
      let self = this
      self.loading = true
      $http.GET({
        url:
          this.$store.state.apiUrl + "/api/services/app/AdminStatistics/GetActiveUser",
        success(res) {
           self.activeUserData = res
             self.activeUser();
            
          self.loading = false
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
        GetSacnStatistics() {
      let self = this
      self.loading = true
      $http.GET({
        url:
          this.$store.state.apiUrl + "/api/services/app/AdminStatistics/GetSacnStatistics",
        success(res) {
           self.Sacndata = res
             self.ScanChart();

          self.loading = false
        },
        fail(res) {
          self.loading = false;
        }
      });
    },
  
    // 总数据
    getDataSum(data) {
      return [
        {title: '待处理', value: data.pending},
        {title: '商品', value: data.commodity},
        {title: '订单', value: data.order},
      ]
    },
    //用户图表
    initChart() {
       let self = this;
      var myChart = echarts.init(document.getElementById("myChart"));
     console.table(self.chartData); 
       // 绘制图表
      myChart.setOption({
        xAxis: {
          name: "日期",
          type: "category",
          boundaryGap: false,
          data: self.chartData.date
        },
        yAxis: {
          name: "",
          type: "value"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        series: [
          {
            data: self.chartData.value,
            type: "line",
            hoverAnimation: true,
            smooth: true,
            areaStyle: {},
            itemStyle: {
              borderColor: "#000",
              color: "#DBEEFC"
            },
            lineStyle: {
              color: "#49A9EE"
            }
          }
        ]
      });
     
    },

      activeUser() {
       let self = this;
      var myChart = echarts.init(document.getElementById("myChartPie"));
       // 绘制图表
      myChart.setOption({
        xAxis: {
          name: "日期",
          type: "category",
          boundaryGap: false,
          data: self.activeUserData.date
        },
        yAxis: {
          name: "",
          type: "value"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        series: [
          {
            data: self.activeUserData.value,
            type: "line",
            hoverAnimation: true,
            smooth: true,
            areaStyle: {},
            itemStyle: {
              borderColor: "#000",
              color: "#DBEEFC"
            },
            lineStyle: {
              color: "#49A9EE"
            }
          }
        ]
      });
     
    },
     //活动图表
    ScanChart() {
       let self = this;
      var myChart = echarts.init(document.getElementById("myChartScan"));
       // 绘制图表
      myChart.setOption({
        xAxis: {
          name: "日期",
          type: "category",
          boundaryGap: false,
          data: self.Sacndata.date
        },
        yAxis: {
          name: "",
          type: "value"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        series: [
          {
            data: self.Sacndata.value,
            type: "line",
            hoverAnimation: true,
            smooth: true,
            areaStyle: {},
            itemStyle: {
              borderColor: "#000",
              color: "#DBEEFC"
            },
            lineStyle: {
              color: "#49A9EE"
            }
          }
        ]
      });
     
    },
  },
  created() {},
  mounted() {
    // this.initChart();
    // this.initChart2();
    this.getStatisticsByItem();
    this.GetRegisterUser(); 
    this.GetActiveUser();
  }
};
</script>
<style lang="scss" scoped>
.commodityStatistics {
  .content {
    padding: 0 50px;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
  }
  .title {
    padding-left: 20px;
    background: #f3f3f3;
    line-height: 50px;
  }
  .pagination-wrapper {
    text-align: center;
    margin: 30px auto;
  }
 .cardBox {
  margin: 0 auto;
  margin-top: 40px;
  padding-bottom: 20px;
  .row {
    display: flex;
    justify-content: space-around;
    .box-card {
      padding: 20px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      display: flex;
      align-items: center;
      background: #fff;
      i {
        width: 50px;
        height: 50px;
        display: block;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 100% 100%;
        &.one {
          background-image: url("./../../assets/imgs/u227.png");
        }
        &.two {
          background-image: url("./../../assets/imgs/u250.png");
        }
        &.three {
          background-image: url("./../../assets/imgs/u303.png");
        }
        &.four {
          background-image: url("./../../assets/imgs/day7.png");
        }
      }
      .txt {
        flex: 1;
        margin-left: 20px;
        p {
          color: #666;
          margin-bottom: 5px;
        }
      }
    }
  }
}
}
</style>